import { Row, Col, Image } from 'react-bootstrap'
import { FaStar } from 'react-icons/fa'
import Link from 'next/link'

const Featured = (category) => (
    <Row className="my-5">
        <Col md={6}>
            <Link href=""><a><Image src={category.category  ? category.category.image : ''} alt="Featured Image" className="img-fluid"/> </a></Link>
        </Col>
        <Col md={6}>
            
            <p className="h5 text-green"><strong>{category.category  ? category.category.month : ''}</strong></p>
            <Link href=""><a className="text-reset text-decoration-none d-block mb-4"><strong>{category.category  ? category.category.month : ''} | {category.category  ? category.category.title : ''}</strong></a></Link>
            <p className="issueText">In this issue:</p>
            <div dangerouslySetInnerHTML={{__html: category.category ? category.category.description : ""}}></div>
            <div className="d-sm-flex justify-content-between mt-4 align-items-center">
                <Link href={category.category ? category.category.link : ""}><a className="px-4 py-2 d-inline-block border h7 bw-2 rounded-pill text-decoration-none border-green text-green btn-trans-green btnread">Read more</a></Link>
                <small><FaStar className="text-warning"/> Value: 5pts</small>
            </div>
            
        </Col>
    </Row>
);

export default Featured;